import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-4 border-b flex justify-between items-center" }
const _hoisted_2 = { class: "text-xl font-bold" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "text-lg" }
const _hoisted_6 = { class: "text-blue-600" }
const _hoisted_7 = { class: "text-lg" }
const _hoisted_8 = { class: "text-green-600 font-bold" }
const _hoisted_9 = { class: "overflow-x-auto" }
const _hoisted_10 = { class: "border-collapse border text-sm mx-auto" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "border p-2" }
const _hoisted_13 = { class: "border p-2" }
const _hoisted_14 = { class: "border p-2" }
const _hoisted_15 = { class: "border p-2" }
const _hoisted_16 = { class: "border p-2" }
const _hoisted_17 = { class: "border p-2" }
const _hoisted_18 = { class: "border p-2" }
const _hoisted_19 = { class: "border p-2" }
const _hoisted_20 = { class: "border p-2" }
const _hoisted_21 = { class: "border p-2" }
const _hoisted_22 = { class: "border p-2" }
const _hoisted_23 = {
  colspan: "12",
  class: "border p-2 text-right font-semibold"
}
const _hoisted_24 = { class: "text-blue-600" }

import { ref, onMounted } from 'vue'

type Job = {
  siteInfo?: string
  siteName?: string
  jobDate?: string
  startTime?: string
  endTime?: string
  hours?: number
  totalHours?: number
  payRate?: number
  rate?: number
  adjustment?: number
  adjustmentHours?: number
  remarks?: string
  bonusHours?: number
  netHours?: number
  travelExpense?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PayDetail',
  props: {
    baseUrl: {},
    payId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const payDetails = ref<Job[]>([])
const employeeName = ref('TBC')
const totalPay = ref(0)
const totalHours = ref(0)

const formatDate = (dateStr?: string) => dateStr ? new Date(dateStr).toLocaleDateString('en-GB') : '-'

const printRow = (row: Job) => alert(`Printing: ${row.siteInfo || row.siteName}`)

const fetchPayDetail = async () => {
  try {
    const res = await fetch(`${props.baseUrl}Pays/ShowPayDetail/${props.payId}`, {
      headers: { "Authorization": `Bearer ${localStorage.token}` }
    })
    if (!res.ok) throw new Error(await res.text())
    const data = await res.json()

    //console.log("data for paydetail : ", data)

    if (data.pays && Array.isArray(data.pays.jobs)) {
      payDetails.value = data.pays.jobs;
      totalPay.value = data.pays.totalPay || 0;
      totalHours.value = data.pays.totalHoursForPay || 0;
      employeeName.value = data.pays.employeeName || 'TBC';
    } else if (Array.isArray(data)) {
      payDetails.value = data
      totalPay.value = 0
      totalHours.value = 0
    } else {
      employeeName.value = data.pays.employeeName || 'TBC'
      totalPay.value = data.totalPay || 0
      totalHours.value = data.pays.totalHoursForPay || 0
      payDetails.value = data.payDetails || data.jobs || []
    }
  } catch (e) {
    alert('Failed to load: ' + (e instanceof Error ? e.message : 'Unknown error'))
  }
}

onMounted(fetchPayDetail)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, [
        _cache[1] || (_cache[1] = _createTextVNode("PAY DETAIL REPORT ", -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
          class: "text-gray-500 hover:text-gray-700 text-right"
        }, "×")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold" }, "Pay Detail For Employee:", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(employeeName.value || 'TBC'), 1)
        ]),
        _createElementVNode("p", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-semibold" }, "Total Pay:", -1)),
          _createElementVNode("span", _hoisted_8, "£" + _toDisplayString(totalPay.value || '0.00'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "bg-gray-100" }, [
              _createElementVNode("th", { class: "border p-2" }, "Site Name"),
              _createElementVNode("th", { class: "border p-2" }, "Job Date"),
              _createElementVNode("th", { class: "border p-2" }, "Start Time"),
              _createElementVNode("th", { class: "border p-2" }, "End Time"),
              _createElementVNode("th", { class: "border p-2" }, "Hours"),
              _createElementVNode("th", { class: "border p-2" }, "Rate"),
              _createElementVNode("th", { class: "border p-2" }, "+/-"),
              _createElementVNode("th", { class: "border p-2" }, "Remarks"),
              _createElementVNode("th", { class: "border p-2" }, "B. Hrs."),
              _createElementVNode("th", { class: "border p-2" }, "Net Hrs."),
              _createElementVNode("th", { class: "border p-2" }, "T. Exp.")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (!payDetails.value || payDetails.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("td", {
                    colspan: "12",
                    class: "border p-4 text-center text-gray-500"
                  }, "No records found", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payDetails.value, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(row.siteInfo || row.siteName || '-'), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(formatDate(row.jobDate)), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(row.startTime || '-'), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(row.endTime || '-'), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(row.dutyHours || '-'), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(row.payRate || row.rate || '-'), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(row.adjustment || row.adjustmentHours || '-'), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(row.remarks || '-'), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(row.bonusHours || '-'), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(row.netHours || '-'), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(row.travelExpense || '-'), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("tfoot", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_23, [
                _cache[5] || (_cache[5] = _createTextVNode(" Total Hours = ", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(totalHours.value), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})